import { render, staticRenderFns } from "./ServerPausedAlerts.vue?vue&type=template&id=7c4e0dda&"
import script from "./ServerPausedAlerts.vue?vue&type=script&lang=js&"
export * from "./ServerPausedAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports